import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function ImpersonationBanner() {
  const { impersonation, endImpersonation } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setBusy(false);
    setError(null);
  }, [impersonation?.targetUserId]);

  if (!impersonation) return null;

  async function onExit() {
    setBusy(true);
    setError(null);
    try {
      await endImpersonation();
      setBusy(false);
      navigate("/admin/users", { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : "Could not exit impersonation");
      setBusy(false);
    }
  }

  return (
    <div className="impersonation-banner" role="status">
      <div className="impersonation-banner-copy">
        <strong>Impersonating</strong>
        <span>
          {impersonation.targetEmail} ({impersonation.targetRole})
        </span>
        {error ? <span className="impersonation-banner-error">{error}</span> : null}
      </div>
      <button type="button" className="btn tight secondary" disabled={busy} onClick={() => void onExit()}>
        {busy ? "Exiting…" : "Exit impersonation"}
      </button>
    </div>
  );
}
